/* @ngInject */
const sortOptions = (
  utils,
  types,
  excelStyles,
) => {
  const self = {}

  self.generateOptions = (_options) => {
    const options = utils.copy(_options)
    options.filename = 'sorting'
    options.enableColor = true
    options.enableOwnerSheet = false
    options.firstRow = 4
    options.getBodyCells = self.getBodyCells
    options.style = excelStyles.bodyCell()

    return options
  }

  self.getBodyCells = ({ currentRow, }, wagon,) => {
    return [{
      name: 'A' + currentRow,
      ref: 'id',
      value: wagon.id,
      type: types.wagonId,
    }, {
      name: 'B' + currentRow,
      ref: 'owner',
      value: wagon.owner,
    }, {
      name: 'C' + currentRow,
      ref: 'typeAndSet',
      value: wagon.typeAndSet,
    }, {
      name: 'D' + currentRow,
      ref: 'railway',
      value: wagon.railway,
    }, {
      name: 'E' + currentRow,
      ref: 'ratioPosition',
      value: wagon.ratioPosition,
    }, {
      name: 'F' + currentRow,
      ref: 'arrivalDate',
      value: wagon.arrivalDate,
      type: types.date,
    }, {
      name: 'G' + currentRow,
      ref: 'completeRevisionExcel',
      value: wagon.completeRevisionExcel,
    }, {
      name: 'H' + currentRow,
      ref: 'length',
      value: wagon.length,
      type: types.decimal,
    }, {
      name: 'I' + currentRow,
      ref: 'case',
      value: wagon.case,
    }, {
      name: 'J' + currentRow,
      ref: 'status',
      value: wagon.status,
    }, {
      name: 'K' + currentRow,
      ref: 'state',
      value: wagon.state,
    }, {
      name: 'L' + currentRow,
      ref: 'damaged',
      value: wagon.damaged,
      type: types.boolean,
    }, {
      name: 'M' + currentRow,
      ref: 'isolated',
      value: wagon.isolated,
      type: types.boolean,
    },]
  }

  return self
}
export default sortOptions



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/wagon/sortOptions.resource.js